import React from 'react';

export default class CategoryChoiceBox extends React.Component {

    render () {

        let message = this.props.message
        let isChecked = this.props.checked
        let onClick = this.props.onClick

        return (
            <div>
                {
                    isChecked === true ?
                        <button onClick={onClick} style={{
                            cursor: 'pointer',
                            borderRadius: '15px',
                            fontSize: '20px',
                            border: '2px solid #42B1B2',
                            background: 'rgba(138,208,209,0.33)',
                            paddingTop: '5px',
                            width: "30vw",
                            minWidth: '600px',
                            height: '45px',
                            color: '#192438',
                            textAlign: 'center',
                            marginBottom: "10px"
                        }}>{message}</button>
                        :
                        <button onClick={onClick} style={{
                            cursor: 'pointer',
                            borderRadius: '15px',
                            fontSize: '20px',
                            background: '#F4F6F8',
                            paddingTop: '5px',
                            minWidth: '600px',
                            width: "30vw",
                            height: '45px',
                            color: '#192438',
                            textAlign: 'center',
                            marginBottom: "10px",
                            border: "none"
                        }}>{message}</button>
                }

            </div>
        )
    }
}
